import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetItemFromInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/GetItemFromInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
const GetItemFromInvoiceableController = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemFromInvoiceableController.url(args, options),
    method: 'get',
})

GetItemFromInvoiceableController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/person/{person}/invoice',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetItemFromInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/GetItemFromInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
GetItemFromInvoiceableController.url = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            person: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return GetItemFromInvoiceableController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetItemFromInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/GetItemFromInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
GetItemFromInvoiceableController.get = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemFromInvoiceableController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetItemFromInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/GetItemFromInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
GetItemFromInvoiceableController.head = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemFromInvoiceableController.url(args, options),
    method: 'head',
})

export default GetItemFromInvoiceableController